// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag__yzlXx","dark":"Tag_dark__3nQ4t","minimal":"Tag_minimal__2ChuY","interactive":"Tag_interactive__18tmH"};